import Button from '@mui/material/Button'
import CentredBanner from '../CentredBanner'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { observer } from "mobx-react-lite"
import { useOrgGuardStore } from '../../../OrgGuardStore';
import { pluralise } from '@gap/utils/language-utils'
import useStore from 'reusable/mobx-store-utils';
import Typography from '@mui/material/Typography';
import { useOrgSubscriptionTierStore } from '../../org-subscription-tiers/OrgSubscriptionTierStore';

export default observer(function BannerTrialPeriod() {
   const orgGuardStore = useOrgGuardStore()
   const orgSubscriptionTierStore = useOrgSubscriptionTierStore()
   const bannerTrialPeriodStore = useStore((sp) => ({
      get endDate(): string | undefined {
         return sp.orgGuardStore.trialEndDate
      },
      // Undefined when the org is on a trial but has no end date set — render a generic message instead of crashing.
      get daysUntilTrialEnd(): number | undefined {
         return bannerTrialPeriodStore.endDate ? orgSubscriptionTierStore.daysUntilDate(bannerTrialPeriodStore.endDate) : undefined
      },
      // A trial Chargebee already cancelled reads as expired even when the clock is minutes off.
      get isEndDateAfterToday() {
         return !sp.orgGuardStore.isOnExpiredTrial && (bannerTrialPeriodStore.daysUntilTrialEnd ?? 0) > 0
      }
   }), { orgGuardStore })

   return <CentredBanner callToAction={
      <Button
         size="small"
         variant="contained"
         endIcon={<AutoAwesomeOutlinedIcon />}
         onClick={orgSubscriptionTierStore.upgradePlanModal.open}
      >Choose a plan</Button>
   }>
      {bannerTrialPeriodStore.daysUntilTrialEnd === undefined
         ? <Typography>You're on a free trial. Choose a plan to continue.</Typography>
         : bannerTrialPeriodStore.isEndDateAfterToday
            ? <Typography>You have {bannerTrialPeriodStore.daysUntilTrialEnd} {pluralise(bannerTrialPeriodStore.daysUntilTrialEnd, 'day', 'days')} remaining on your trial</Typography>
            : <Typography>Your trial has expired, please choose a plan to continue</Typography>}
   </CentredBanner>
})
